/**
 * 「已选料号」展示：仓库料号优先，其次系统料号；不用材料身份编码冒充仓库料号。
 * @param {object|null|undefined} mm material_matching 或含同名字段的对象
 * @returns {string}
 */
export function selectedBatchDisplay (mm) {
  if (!mm) return '—'
  const v =
    mm.warehouse_lots_display ||
    mm.selected_batch_display ||
    mm.warehouse_manual_code ||
    mm.material_batch_number
  if (v != null && String(v).trim() !== '') return String(v).trim()
  return '待填仓库料号'
}

/** 是否为系统料号回退（无仓库料号时） */
export function selectedBatchDisplayIsSystemFallback (mm) {
  if (!mm) return false
  const hasWh =
  (mm.warehouse_lots_display && String(mm.warehouse_lots_display).trim()) ||
  (mm.warehouse_manual_code && String(mm.warehouse_manual_code).trim()) ||
  (mm.selected_batch_display_kind === 'warehouse')
  if (hasWh) return false
  return !!(mm.material_batch_number && String(mm.material_batch_number).trim())
}

/** 配料页「仓库料号」输入框占位：无仓库料号时提示系统料号，但不写入输入值 */
export function warehouseManualCodePlaceholder (mm) {
  const base = '请输入或选择仓库料号'
  if (!mm) return base
  if (String(mm.warehouse_manual_code || '').trim()) return base
  const sys = String(mm.material_batch_number || '').trim()
  if (sys) return `无仓库料号（系统: ${sys}）`
  return base
}
